// =========================
// LANDING PAGE
// =========================
import App from './../../App';
import { html, render } from 'lit-html';
import { gotoRoute, anchorRoute } from './../../Router';
import Auth from './../../Auth';
import Utils from './../../Utils';

// This is the HomeView class that handles the landing page
// It includes methods for rendering the page and handling user interactions
class HomeView {
  constructor() {
    this.popupErrorMessage = '';
  }
  // This method initializes the view
  init() {
    if (Auth.isLoggedIn()) {
      gotoRoute('/feed');
      return;
    }

    console.log('HomeView.init');
    document.title = 'PopIn';
    this.render();
    Utils.pageIntroAnim();
  }

  // This method handles the login form submission in the popup
  // It prevents the default form submission behavior, collects the form data,
  logInSubmitHandler(e) {
    e.preventDefault();
    const form = e.target;
    const submitBtn = form.querySelector('.submit-btn');
    submitBtn.setAttribute('loading', '');

    const formData = new FormData(form);

    Auth.signIn(formData)
      .then(() => {
        submitBtn.removeAttribute('loading');
        this.popupErrorMessage = '';
        document.getElementById('loginPopup').active = false;
      })
      .catch((err) => {
        submitBtn.removeAttribute('loading');
        this.popupErrorMessage = 'Invalid email or password.';
        this.render();
      });
  }

  // This method toggles the login popup
  toggleLoginPopup() {
    const popup = document.getElementById('loginPopup');
    this.popupErrorMessage = '';
    this.render();

    popup.placement = window.innerWidth <= 1024 ? 'bottom' : 'bottom-start';
    popup.active = !popup.active;
  }

  render() {
    const template = html`
      <nav>
        <div>
          <a href="/" @click=${anchorRoute}><img src="images/logo.svg" /></a>
        </div>
        <div>
          <sl-button
            variant="primary"
            id="loginToggleBtn"
            @click=${this.toggleLoginPopup}
            >Log In</sl-button
          >

          <sl-popup
            class="login-popup"
            id="loginPopup"
            anchor="loginToggleBtn"
            placement="bottom-start"
            arrow
          >
            <form id="loginForm" @submit=${this.logInSubmitHandler.bind(this)}>
              ${this.popupErrorMessage
                ? html`
                    <sl-alert variant="danger" open closable>
                      <sl-icon slot="icon" name="exclamation-octagon"></sl-icon>
                      <span>${this.popupErrorMessage}</span>
                    </sl-alert>
                  `
                : ''}
              <sl-input
                name="email"
                type="email"
                placeholder="Email"
                required
              ></sl-input>
              <sl-input
                name="password"
                type="password"
                placeholder="Password"
                required
              ></sl-input>
              <sl-button
                type="submit"
                variant="neutral"
                class="submit-btn"
                variant="primary"
                >Log In</sl-button
              >
            </form>
          </sl-popup>

          <sl-button
            variant="default"
            outline
            class="anim-in"
            @click=${() => gotoRoute('/signup')}
            >Sign Up</sl-button
          >
        </div>
      </nav>

      <div id="landing">
        <div id="hero-left">
          <h1 class="hero-left-el">Where your next great night out begins</h1>
          <p class="hero-left-el">
            Find events you love, share your plans, and connect with your crew.
            From gigs to gallery openings, PopIn is your new go-to for what’s
            happening near you.
          </p>
          <sl-button
            variant="success"
            class="hero-left-el anim-in"
            @click=${() => gotoRoute('/signup')}
            >Discover PopIn!</sl-button
          >
        </div>
        <div id="hero-right">
          <img src="images/hero.png" />
        </div>
      </div>

      <footer>
        <div>
          <img src="images/icon.svg" />
        </div>
        <p>
          This website is the official online presence of PopIn. All content,
          including images and text, is the property of PopIn or its respective
          owners and is used with permission. Unauthorized reproduction or
          distribution of any material on this site is prohibited. For inquiries
          regarding content usage, please contact us directly.
        </p>
        <div>
          <sl-icon src="images/square-instagram-brands.svg"></sl-icon>
          <sl-icon src="images/square-facebook-brands.svg"></sl-icon>
          <sl-icon src="images/square-tiktok-brands.svg"></sl-icon>
          <sl-icon src="images/square-x-twitter-brands.svg"></sl-icon>
          <sl-icon src="images/square-linkedin-brands.svg"></sl-icon>
        </div>
      </footer>
    `;
    render(template, App.rootEl);
  }
}

export default new HomeView();
